import localeText from "../../locale";

const showErrorToast = (toast, detail) => (code, backendMessage) => {
  const mapped = localeText("data")?.find((entry) => entry.code === code);
  const baseMessage = mapped?.message;
  const mappedMessage =
    code === 500000 && backendMessage && baseMessage
      ? `${baseMessage}: ${backendMessage}`
      : baseMessage;

  toast.show({
    severity: "error",
    summary: localeText("error"),
    detail: detail
      ? localeText(detail) || detail
      : mappedMessage || backendMessage || localeText("errorOfSystem"),
    life: 6000,
  });
};

export default showErrorToast;
